import {
  ArrowDownToLine,
  Banknote,
  BarChart3,
  BookOpen,
  ClipboardList,
  Contact,
  DatabaseBackup,
  FileText,
  Gauge,
  Gift,
  LayoutDashboard,
  MapPinIcon,
  Megaphone,
  PackageIcon,
  Percent,
  RotateCcw,
  ShoppingBag,
  SlidersHorizontal,
  Ticket,
  TrendingUp,
  Truck,
  UserCog,
  Users,
  Wallet,
} from "lucide-react";
import type { SidebarData } from "../types";

export const sidebarData: SidebarData = {
  navGroups: [
    {
      title: "ທົ່ວໄປ",
      items: [
        {
          title: "ແຜງຄວບຄຸມ",
          url: "/app/dashboard",
          icon: LayoutDashboard,
        },
      ],
    },
    {
      title: "ການຂາຍ",
      items: [
        {
          title: "ອໍເດີ (HQ)",
          url: "/app/orders",
          icon: ShoppingBag,
          requiredPermissions: ["orders:read"],
          notificationId: "orders_pending_confirmation",
        },
        {
          title: "ລູກຄ້າ",
          url: "/app/customers",
          icon: Contact,
          requiredPermissions: ["orders:read"],
          notificationId: "customers_kyc_pending",
        },
      ],
    },
    {
      title: "ສາຂາ",
      items: [
        {
          title: "ສາຂາ",
          url: "/app/branches",
          icon: MapPinIcon,
          requiredPermissions: ["branches:read"],
        },
      ],
    },
    {
      title: "ສິນຄ້າ ແລະ ລາຄາ",
      items: [
        {
          title: "ສິນຄ້າ / ເມນູ",
          url: "/app/catalog/products",
          icon: PackageIcon,
          requiredPermissions: ["catalog:read"],
        },
        {
          title: "ຊຸດຕົວເລືອກ",
          url: "/app/catalog/modifiers",
          icon: SlidersHorizontal,
          requiredPermissions: ["catalog:read"],
        },
        {
          title: "ລາຄາຕໍ່ສາຂາ",
          url: "/app/pricing/branch-overrides",
          icon: Banknote,
          requiredPermissions: ["pricing:read"],
        },
        {
          title: "ປຽບທຽບລາຄາຕໍ່ສາຂາ",
          url: "/app/pricing/compare",
          icon: Banknote,
          requiredPermissions: ["pricing:read"],
        },
      ],
    },
    {
      title: "Wallet",
      items: [
        {
          title: "ບັນຊີ Wallet",
          url: "/app/wallet/accounts",
          icon: Wallet,
          requiredPermissions: ["wallet:read"],
        },
        {
          title: "ຄິວອະນຸມັດເຕີມເງິນ",
          url: "/app/wallet/topup-queue",
          icon: ArrowDownToLine,
          requiredPermissions: ["wallet:read"],
          notificationId: "wallet_topup_queue",
        },
        {
          title: "ຄິວອະນຸມັດຄືນເງິນ",
          url: "/app/wallet/refund-queue",
          icon: RotateCcw,
          requiredPermissions: ["wallet:read"],
          notificationId: "wallet_refund_queue",
        },
        {
          title: "Ledger Explorer",
          url: "/app/wallet/ledger",
          icon: BookOpen,
          requiredPermissions: ["wallet:read"],
        },
      ],
    },
    {
      title: "ສາງ ແລະ ວັດຖຸດິບ",
      items: [
        {
          title: "ວັດຖຸດິບ",
          url: "/app/inventory/ingredients",
          icon: PackageIcon,
          requiredPermissions: ["inventory:read"],
        },
        {
          title: "ຫມວດວັດຖຸດິບ",
          url: "/app/inventory/ingredient-categories",
          icon: PackageIcon,
          requiredPermissions: ["inventory:read"],
        },
        {
          title: "ເງື່ອນໄຂສຕັອກ",
          url: "/app/inventory/stock-policies",
          icon: Gauge,
          requiredPermissions: ["inventory:read"],
        },
        {
          title: "ລາຍການ Lot",
          url: "/app/inventory/lots",
          icon: PackageIcon,
          requiredPermissions: ["inventory:read"],
          notificationId: "inventory_near_expiry",
        },
        {
          title: "ປະຫວັດ Movement",
          url: "/app/inventory/movements",
          icon: PackageIcon,
          requiredPermissions: ["inventory:read"],
        },
        {
          title: "ຄຳຂໍເບິກສະຕ໋ອກ",
          url: "/app/inventory/transfers",
          icon: PackageIcon,
          requiredPermissions: ["inventory:transfer:read"],
          notificationId: "inventory_transfers_submitted",
        },
        {
          title: "ຜູ້ສະໜອງ",
          url: "/app/inventory/suppliers",
          icon: Truck,
          requiredPermissions: ["inventory:purchase:read"],
        },
        {
          title: "ໃບສັ່ງຊື້ (PO)",
          url: "/app/inventory/purchase-orders",
          icon: ClipboardList,
          requiredPermissions: ["inventory:purchase:read"],
          notificationId: "inventory_purchase_orders_submitted",
        },
        {
          title: "ລາຍງານ PO",
          url: "/app/reports/inventory/purchase-orders",
          icon: FileText,
          requiredPermissions: ["inventory:purchase:read"],
        },
        {
          title: "ລາຍງານສຕັອກເຫຼືອຫນ້ອຍ",
          url: "/app/reports/inventory/low-stock",
          icon: Gauge,
          requiredPermissions: ["reports:inventory:read"],
        },
      ],
    },
    {
      title: "ນະໂຍບາຍ ແລະ ໂປຣໂມຊັນ",
      items: [
        {
          title: "ຕັ້ງຄ່ານະໂຍບາຍ",
          url: "/app/loyalty/settings",
          icon: Gift,
          requiredPermissions: ["loyalty:read"],
        },
        {
          title: "ບັດສະມາຊິກ",
          url: "/app/membership/settings",
          icon: Gift,
          requiredPermissions: ["membership:read"],
        },
        {
          title: "ລາງວັນ",
          url: "/app/loyalty/rewards",
          icon: Gift,
          requiredPermissions: ["loyalty:read"],
        },
        {
          title: "ໂປຣໂມຊັນ",
          url: "/app/loyalty/promotions",
          icon: Percent,
          requiredPermissions: ["loyalty:read"],
        },
        {
          title: "ຄູປອງ",
          url: "/app/loyalty/promotions/coupons",
          icon: Ticket,
          requiredPermissions: ["loyalty:read"],
        },
        {
          title: "ຂ່າວສານ",
          url: "/app/announcements",
          icon: Megaphone,
          requiredPermissions: ["announcements:read"],
        },
      ],
    },
    {
      title: "ລາຍງານ",
      items: [
        {
          title: "ລາຍງານການຂາຍ",
          url: "/app/reports/sales",
          icon: TrendingUp,
          requiredPermissions: ["reports:sales:read"],
        },
        {
          title: "ລາຍງານການດຳເນີນງານ",
          url: "/app/reports/operations",
          icon: BarChart3,
          requiredPermissions: ["reports:ops:read"],
        },
        {
          title: "ລາຍງານ Wallet",
          url: "/app/reports/wallet",
          icon: Wallet,
          requiredPermissions: ["reports:wallet:read"],
        },
        {
          title: "ລາຍງານສາງ",
          url: "/app/reports/inventory",
          icon: FileText,
          requiredPermissions: ["reports:inventory:read"],
        },
        {
          title: "ລາຍງານເບິກສະຕ໋ອກ",
          url: "/app/reports/inventory/transfers",
          icon: PackageIcon,
          requiredPermissions: ["reports:inventory:read"],
        },
        {
          title: "ລາຍງານ PO",
          url: "/app/reports/inventory/purchase-orders",
          icon: ClipboardList,
          requiredPermissions: ["reports:inventory:read"],
        },
        {
          title: "ລາຍງານສຕັອກເຫຼືອຫນ້ອຍ",
          url: "/app/reports/inventory/low-stock",
          icon: Gauge,
          requiredPermissions: ["reports:inventory:read"],
        },
      ],
    },
    {
      title: "ການຄຸ້ມຄອງລະບົບ",
      items: [
        {
          title: "ບົດບາດ",
          url: "/app/roles",
          icon: UserCog,
          requiredPermissions: ["users:read"],
        },
        {
          title: "ຜູ້ໃຊ້",
          url: "/app/users",
          icon: Users,
          requiredPermissions: ["users:read"],
        },
        {
          title: "ສຳຮອງຂໍ້ມູນ",
          url: "/app/system/backup",
          icon: DatabaseBackup,
          requiredPermissions: ["system:backup"],
        },
      ],
    },
    // {
    //   title: "ລະບົບ",
    //   items: [
    //     {
    //       title: "ບັນທຶກການກວດກາ",
    //       url: "/app/audit",
    //       icon: ShieldCheck,
    //       requiredPermissions: ["audit:read"],
    //     },
    //   ],
    // },
  ],
};
